import { useState } from "react";
import { formatPhoneNumber } from "@/app/utils/formatPhoneNumber";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/view/components/ui/avatar";
import { stringToColour } from "@/app/utils/changeBackgroundColorOfInitials";
import { getNameInitial } from "@/app/utils/getNameInitial";
import { Button } from "@/view/components/ui/button";
import { GetPublicUserResponse } from "@/app/services/selfHireService/getPublicUser";

export const FloatingSellerButton = ({
  handleWhatsAppClick,
  seller,
}: {
  handleWhatsAppClick: () => void;
  seller: GetPublicUserResponse | undefined;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="fixed bottom-6 right-6 z-50"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Button
        onClick={handleWhatsAppClick}
        variant="ghost"
        className="flex h-16 w-16 items-center justify-center rounded-full bg-gray01 shadow-lg transition-all duration-200 hover:bg-gray01 sm:h-20 sm:w-20"
        title={`Falar com ${seller?.name}`}
      >
        <div className="flex flex-col items-center gap-1">
          <Avatar className="h-12 w-12 sm:h-16 sm:w-16">
            <AvatarImage
              src={
                seller?.profileImageUrl
                  ? `${import.meta.env.VITE_CDN_URL}${seller?.profileImageUrl}`
                  : undefined
              }
            />
            <AvatarFallback
              className="text-xs sm:text-sm"
              style={{
                backgroundColor: stringToColour(seller?.name || ""),
              }}
            >
              {getNameInitial(seller?.name || "")}
            </AvatarFallback>
          </Avatar>
        </div>
      </Button>

      <div
        className={`pointer-events-none absolute bottom-full right-0 mb-2 w-48 rounded-lg bg-black01 px-3 py-2 text-sm text-white01 transition-opacity duration-200 sm:block ${
          isHovered ? "opacity-100" : "opacity-0"
        }`}
      >
        <div className="text-center">
          <p className="font-semibold">Precisa de ajuda?</p>
          <p className="text-xs">{seller?.name}</p>
          <p className="text-xs">{formatPhoneNumber(seller?.phone || "")}</p>
        </div>
        <div className="absolute right-4 top-full h-0 w-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black01"></div>
      </div>
    </div>
  );
};
